import Symbol from "./Symbol";
import { INSPECTOR_SOFT_STARTER } from "../../../constants/inspectorConstants";

// Arrancador Suave
class SoftStarter extends Symbol {
    constructor({ alias, svgSrc, label, rotable, handles, name}) {
        super("SoftStarter", { alias, svgSrc, label, rotable, handles, name });

        this.attributes = {
            ...this.attributes,
            brand: { isVisible: false, value: null, label: null },
            model: { isVisible: false, value: null, label: null },
            numberPhases: { isVisible: false, value: null, label: null },
            ratedCurrent: { isVisible: false, value: null, label: null },
            ratedVoltage: { isVisible: false, value: null, label: null },
            interruptingCapacity: { isVisible: false, value: null, label: null },
            instantAdjustment: { isVisible: false, value: null, label: null },
        };                
    }

    getInspector() {
        return INSPECTOR_SOFT_STARTER;
    }
}

export default SoftStarter;
